import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common/services/common.service';
import { UserAccountService } from '../user-account.service';

@Component({
    selector: 'app-booking-list',
    templateUrl: 'booking-list.component.html',
    styleUrls:['./booking-list.component.css']
})

export class BookingListComponent implements OnInit {
    @Input() bookingDetails: any = [];
    constructor(private _router: Router,public _commonService: CommonService, private _userAccountService: UserAccountService) { }

    ngOnInit() { }

    gotoBookingDetail(book:any){
        console.log("dddddddd",book)
        //this._userAccountService.setBookingDetail(book);
        this._router.navigate(['booking/detail/'+book]);
      }
}